import React, {createContext, useCallback, useEffect, useState} from 'react';
import ResponsiveDrawer from './Header';
import Footer from "./Footer";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import {Container} from "@material-ui/core";
import Home from "./Home";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import Watch from './Watch';
import Schedule from "./Schedule";
import {JsonContext} from "../Context";
import {fetchFeJson} from "../utils/api";
import {apiTimeInterval} from "../constant";
import {getImage} from '../utils/image'
const useStyles = makeStyles((theme) => ({
    mainContainer: {
        overflow: "hidden",
        background: '#111111',
        minHeight: '90vh'
    },
}));

export default function Main(){
    const classes = useStyles();
    const theme = useTheme();
    const [feJson, setFeJson] = useState(null);
    let count = 0;
    const fetchFrontJson = () => {
        count++;
        fetchFeJson().then(result => {
            result && setFeJson({...result, count})
        })
    }

    useEffect(()=>{
        let meta = document.createElement('meta');
        meta.setAttribute('property', 'og:image');
        meta.content = getImage('WSFB_OG_1200x630.jpg');
        document.getElementsByTagName('head')[0].appendChild(meta);
        fetchFrontJson();
        setInterval(fetchFrontJson,apiTimeInterval * 1000)
    },[]);

    return(
        <JsonContext.Provider value={feJson}>
        <div style={{fontFamily: theme.body.font.primary}}>
                        {feJson && <BrowserRouter>
                <ResponsiveDrawer data={feJson.header}/>
                <div className={classes.mainContainer}>
                    <Switch>
                        <Route exact path='/' component={Home}/>
                        <Route path='/schedule' component={Schedule}/>
                        <Route path='/watch/:id' component={Watch}/>
                    </Switch>
                </div>
                <Footer data={feJson.footer}/>
            </BrowserRouter>}

        </div>
        </JsonContext.Provider>
    )
}